import { Message } from '@/types/mesage';
import { create } from 'zustand';

interface MessageState {
  messages: Message[];
  addMessage: (message: Message) => void;
  clearMessages: () => void;
}

const useMessageStore = create<MessageState>((set) => ({
  messages: [],
  addMessage: (message) =>
    set((state) => {
      const newMessage: Message = {
        ...message,
        id: crypto.randomUUID(), // Assign a unique id using crypto API
      };
      return { messages: [...state.messages, newMessage] };
    }),
  clearMessages: () => set({ messages: [] }),
}));

export default useMessageStore;
